<form class="empresa-form-content" (ngSubmit)="submit()">
  <div class="form-heading">
    <div>
      <span class="eyebrow">Administración de empresas</span>
      <h2>{{ empresa ? 'Editar empresa' : 'Nueva empresa' }}</h2>
    </div>
    <button class="close-button" type="button" (click)="cancelled.emit()" aria-label="Cerrar">
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <p class="form-description">
    Registra la información fiscal de la empresa y define las condiciones de su suscripción.
  </p>

  <div class="form-grid">
    <label class="full-width">
      Razón social
      <input
        name="razonSocial"
        [(ngModel)]="form.razonSocial"
        maxlength="200"
        required
        placeholder="Ej. Empresa S.A."
      />
    </label>
    <label>
      RUC o identificación fiscal
      <input
        name="identificacionFiscal"
        minlength="10"
        maxlength="20"
        inputmode="numeric"
        pattern="[0-9]{10,20}"
        required
        [(ngModel)]="form.identificacionFiscal"
        placeholder="Ej. 1790000001001"
      />
    </label>
    <label for="planes">
      Plan de suscripción
      <app-select
        name="planId"
        [(ngModel)]="form.planId"
        [options]="planOptions"
        [clearable]="false"
        [disabled]="!planes.length"
        placeholder="Selecciona un plan"
        aria-label="Plan de suscripción"
      />
      @if (!planes.length) {
        <small>No hay planes disponibles.</small>
      }
    </label>
    <label>
      Fecha de inicio
      <input name="fechaInicio" type="date" required [(ngModel)]="form.fechaInicio" />
    </label>
    <label>
      Fecha de finalización <small>(opcional)</small>
      <input name="fechaFin" type="date" [(ngModel)]="form.fechaFin" />
    </label>
    @if (empresa) {
      <label class="checkbox-field full-width">
        <input name="estado" type="checkbox" [(ngModel)]="form.estado" />
        <span>
          <strong>Empresa activa</strong>
        </span>
      </label>
    }
  </div>

  @if (error || serverError) {
    <div class="form-error">
      <i class="fa-solid fa-circle-exclamation"></i>{{ error || serverError }}
    </div>
  }

  <footer class="form-actions">
    <button class="secondary-button" type="button" (click)="cancelled.emit()">Cancelar</button>
    <button class="primary-button" type="submit" [disabled]="!planes.length">
      <i class="fa-solid fa-check"></i>{{ empresa ? 'Guardar cambios' : 'Crear empresa' }}
    </button>
  </footer>
</form>
